module.exports = __webpack_public_path__ + "static/media/0030_IMG_LES_ENSEIGNES_LE_PRIMEUR_LETTRE_A_LETTRE.f87a60e7.png";